import { InformationVariantBoxOutlineIcon } from './InformationVariantBoxOutlineIcon';

/**
 * author: Jeff Anders
 * id 4D7338FF-73D3-49EC-A9A8-070039557830
 * name information-variant-box-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-variant-box-outline.svg
 * tags
 * - Settings 
 */
export const InfoVariantBoxOutlineIcon = InformationVariantBoxOutlineIcon;
export default InfoVariantBoxOutlineIcon